<div>
  <span>
    <a routerLink="/login" (click)="handleLoginClick($event)">Login</a>
  </span>
  |
  <span>
    <a
      routerLink="/about"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      >About</a
    >
  </span>
  |
  <span>{{ year }} Copyright: FirsTech, Inc.</span> |
  <span>
    <a routerLink="/terms">Terms &amp; Conditions</a>
  </span>
</div>
